import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/contexts/AuthContext';
import { OnboardingProvider } from '@/contexts/OnboardingContext';
import { SubscriptionProvider } from '@/contexts/SubscriptionContext';
import { TestSessionProvider } from '@/contexts/TestSessionContext';
import RootErrorBoundary from '@/components/error/RootErrorBoundary';
import { router } from '@/router';

export default function App() {
  return (
    <RootErrorBoundary>
      <AuthProvider>
        <OnboardingProvider>
          <SubscriptionProvider>
            <TestSessionProvider>
              <RouterProvider router={router} />
            </TestSessionProvider>
            <Toaster
              position="bottom-right"
              offset={24}
              duration={5000}
              toastOptions={{
                style: {
                  fontFamily: 'var(--font-sans)',
                  background: 'var(--color-cream)',
                  color: 'var(--color-text-primary)',
                  border: '1px solid var(--color-border)',
                  borderRadius: '18px',
                  boxShadow: '0 8px 32px rgba(45, 36, 22, 0.10)',
                  padding: '14px 16px',
                },
                classNames: {
                  error: 'sonner-toast-error',
                  success: 'sonner-toast-success',
                  title: 'sonner-toast-title',
                  description: 'sonner-toast-description',
                  icon: 'sonner-toast-icon',
                },
              }}
            />
          </SubscriptionProvider>
        </OnboardingProvider>
      </AuthProvider>
    </RootErrorBoundary>
  );
}
